import { widgetAccessByOrganization } from './WidgetFormAccessByOrganization/WidgetAccessByOrganization';
import { widgetAccountSearch } from './WidgetFormAccountSearch/WidgetAccountSearch';
import { widgetOrganizationSharing } from './WidgetFormOrganizationSharing/WidgetOrganizationSharing';
export const contactManagementFormWidget = [widgetOrganizationSharing, widgetAccessByOrganization, widgetAccountSearch];
